import { CommandConfig } from '../../CommandConfig';

export default {
  command: 'start',
  description: 'Build and watch project',
  options: [],
} as CommandConfig;
